import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { CxInteractionFormComponent } from 'app/cx-interaction/cx-interaction-form.component';
import { environment } from 'environments/environment';
import { GetInteractionTagLists, SaveCxInteraction } from 'app/store/cx-interaction/cx-interaction.action';
import { CXInteractionState } from 'app/store/cx-interaction/cx-interaction.state';
import { TagLists } from 'app/models/cx-interaction/cx-interaction-tag-list.interface';
import { filter, skip, take, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Component({
  selector: 'app-cx-interaction-smart',
  templateUrl: './cx-interaction-smart.component.html',
  styleUrls: ['./cx-interaction-smart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CxInteractionSmartComponent implements OnInit, OnDestroy {

  @ViewChild(CxInteractionFormComponent) cxInteractionFormComponent: CxInteractionFormComponent;
  @Output() cxDrawerClose = new EventEmitter<boolean>();
  @Output() savedSuccessfully = new EventEmitter<void>();
  tags$: Observable<TagLists[]> = this.store.select(CXInteractionState.tagLists);
  destroyed$ = new Subject<boolean>();
  tagOptions: TagLists[];
  loaded = false;
  formSaving = false;
  @Input() user: LenderUser;
  @Input() callId: number | string | null;
  @Input() borrowerId: number;
  @Input() forcedPrefill: { borrowerId: number | null, interactionType: string | null } | null = null;
  @Input() livePrefill: { borrowerId: number | null, interactionType: string | null } | null = null;
  @Input() locked = false;



  constructor(
    private store: Store,
  ) { }

  ngOnInit(){
    this.store.dispatch(new GetInteractionTagLists());
    this.tags$.pipe(takeUntil(this.destroyed$)).subscribe(
      (options) => {
        if (options === undefined || options.length === 0) {
          return;
        }
        this.tagOptions = options;
      }
    );
  }

  sideNavClose() {
    this.cxDrawerClose.emit(true);
  }

  onSaveCxInteraction(cxInteractionInfo: object) {
    const info = cxInteractionInfo['info'];
    info['lenderUserId'] = this.user.id;
    this.formSaving = true;

    const isCallInteraction = /call/i.test(info['interactionType'] ?? '');
    if (isCallInteraction && this.callId != null) {
      info['modelId'] = this.callId;
      info['type'] = 'call';
      if (info['borrowerId'] === undefined) {
        info['borrowerId'] = this.borrowerId;
      }

      this.store.select((state: any) => state.cxInteraction?.cxInteraction).pipe(
        skip(1),
        filter(Boolean),
        take(1),
        takeUntil(this.destroyed$),
      ).subscribe(() => {
        this.formSaving = false;
        this.savedSuccessfully.emit();
      });

      this.store.dispatch(new SaveCxInteraction(
        info,
        cxInteractionInfo['form'],
        cxInteractionInfo['directive'],
        cxInteractionInfo['cxComponent']
      ));
      return;
    }

    this.store.dispatch(new SaveCxInteraction(
      info,
      cxInteractionInfo['form'],
      cxInteractionInfo['directive'],
      cxInteractionInfo['cxComponent']
    ));
    this.formSaving = false;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }
}
